// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1kXHS","left":"styles_left__38nq8"};